import { Problem as ProblemType } from '@yandex-int/k-common/typings';
import { ProblemLoadable as Problem, Robot } from 'platform-components';
import { PROBLEM_THEMES, SCREEN_RESOLUTIONS } from 'platform-components/constants';
import { isRobotProblem } from 'platform-components/src/components/robot/utils/isRobotProblem';
import React from 'react';

import TeacherProblem from 'common.components/teacher-problem/teacher-problem';

interface Props {
    problem: ProblemType;
    problemBlockPlateStyles: Record<string, object>;
}

export const ThemePageStackProblem = ({ problem, problemBlockPlateStyles }: Props) => {
    const isWithAlignment = Boolean(problem.content_alignment);

    const commonProblemProps = {
        problem,
        previewMode: true,
        readOnly: true,
        teacherMode: true,
    };

    const problemProps = {
        ...commonProblemProps,
        problemBlockPlateStyles,
        showCorrectAnswers: false,
        imageResolution: SCREEN_RESOLUTIONS.X1,
    };

    if (isRobotProblem(problem)) {
        return <Robot {...commonProblemProps} problem={problem} />;
    }

    if (isWithAlignment) {
        return <TeacherProblem {...problemProps} />;
    }

    return <Problem {...(problemProps as any)} theme={PROBLEM_THEMES.SCHOOL} />;
};
